import axios from 'axios'
import jwt from 'jsonwebtoken'

export default {
  namespaced: true,
  state: {
    id: '',
    nick: '',
    type: '',
    email: '',
    loading: false,
    error: null
  },
  mutations: {
    setUser(state, user) {
      state.id = user.id
      state.nick = user.nick
      state.type = user.type
      state.email = user.email
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    logout({ commit }) {
      commit('setUser', { id: '', nick: '', type: '', email: '' })
      localStorage.removeItem('token')
    },
    SOCKET_LOGOUT({ dispatch }) {
      dispatch('logout')
    },
    async signup(tmp, user) {
      try {
        await axios.post(process.env.VUE_APP_API_URL + '/signup', user)
        return true
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async login({ dispatch, commit }, user) {
      commit('setLoading', true)

      commit('setError', null)
      try {
        const response = await axios.post(process.env.VUE_APP_API_URL + '/login', user)
        const token = response.data.token
        dispatch('applyToken', token)
        localStorage.token = token
        return true
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    applyToken({ commit }, token) {
      try {
        const userData = jwt.decode(token)
        commit('setUser', {
          id: userData.id,
          nick: userData.nick,
          type: userData.type,
          email: userData.email
        })
      } catch (err) {
        commit('setError', err)
      }
    }
  },
  getters: {
    user: state => {
      return {
        id: state.id,
        nick: state.nick,
        type: state.type,
        email: state.email
      }
    },
    isLoading: state => {
      return state.loading
    },
    isError: state => {
      return state.error
    }
  }
}
